import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_sous_titre_1Texte, id_sous_titre_1CouleurTexte, id_sous_titre_1Opacite, id_sous_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_paragraphe_2Texte, id_paragraphe_2CouleurTexte, id_paragraphe_2Opacite, id_paragraphe_2Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="sous-titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_sous_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_sous_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_sous_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_sous_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_sous_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_sous_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-2 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_2Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_2Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_2CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_2CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_2Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* Définition des symboles SVG réutilisables */}
                <svg style="display: none;">
                    <symbol id="chevron-up" viewbox="0 0 16 16">
                        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"></path>
                    </symbol>
                    <symbol id="chevron-down" viewbox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"></path>
                    </symbol>
                </svg>
                {/* id_bloc */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            {/* id_titre_1 */}
                            {id_titre_1Afficher && (
                                <RichText 
                                    tagName="h1" 
                                    className="id_titre_1 " 
                                    value={id_titre_1Texte} 
                                    onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                                />
                            )}
                            {/* end-id_titre_1 */}
                            {/* id_sous_titre_1 */}
                            {id_sous_titre_1Afficher && (
                                <RichText 
                                    tagName="h2" 
                                    className="id_sous_titre_1 " 
                                    value={id_sous_titre_1Texte} 
                                    onChange={(val) => setAttributes({ id_sous_titre_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_sous_titre_1CouleurTexte, opacity: id_sous_titre_1Opacite }} 
                                />
                            )}
                            {/* end-id_sous_titre_1 */}
                            {/* id_paragraphe_1 */}
                            {id_paragraphe_1Afficher && (
                                <RichText 
                                    tagName="p" 
                                    className="id_paragraphe_1 " 
                                    value={id_paragraphe_1Texte} 
                                    onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                                />
                            )}
                            {/* end-id_paragraphe_1 */}
                            {/* id_paragraphe_2 */}
                            {id_paragraphe_2Afficher && (
                                <RichText 
                                    tagName="p" 
                                    className="id_paragraphe_2 " 
                                    value={id_paragraphe_2Texte} 
                                    onChange={(val) => setAttributes({ id_paragraphe_2Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_paragraphe_2CouleurTexte, opacity: id_paragraphe_2Opacite }} 
                                />
                            )}
                            {/* end-id_paragraphe_2 */}
                            {/* id_accordeon */}
                            <div className="accordion">
                                {/* id_accordeon_item_{n} */}
                                <div id="id_accordeon_item_{n}" className="accordion-item">
                                    {/* id_accordeon_item_{n}_titre */}
                                    <h2 className="accordion-header" id="id_accordeon_item_{n}_titre">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#id_accordeon_item_{n}_bloc" aria-expanded="false" aria-controls="id_accordeon_item_{n}_bloc">
                                            {/* id_accordeon_item_{n}_titre_texte */}
                                            <span id="id_accordeon_item_{n}_titre_texte">
attribut_id_accordeon_item_{n}_titre_texte_texte
                                            </span>
                                            {/* end-id_accordeon_item_{n}_titre_texte */}
                                            {/* id_accordeon_item_{n}_titre_chevron */}
                                            <svg id="id_accordeon_item_{n}_titre_chevron" width="16" height="16" fill="currentColor" className="bi bi-chevron-down">
                                                <use href="#chevron-down"></use>
                                            </svg>
                                            {/* end-id_accordeon_item_{n}_titre_chevron */}
                                        </button>
                                    </h2>
                                    {/* end-id_accordeon_item_{n}_titre */}
                                    {/* id_accordeon_item_{n}_bloc */}
                                    <div id="id_accordeon_item_{n}_bloc" className="accordion-collapse collapse" data-bs-parent="#id_accordeon">
                                        {/* id_accordeon_item_{n}_bloc_paragraphe_texte */}
                                        <p id="id_accordeon_item_{n}_bloc_paragraphe_texte">
attribut_id_accordeon_item_{n}_bloc_paragraphe_texte_texte
                                        </p>
                                        {/* end-id_accordeon_item_{n}_bloc_paragraphe_texte */}
                                    </div>
                                    {/* end-id_accordeon_item_{n}_bloc */}
                                </div>
                                {/* end-id_accordeon_item_{n} */}
                            </div>
                            {/* end-id_accordeon */}
                        </div>
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}